import React from "react";
import Box from "@mui/material/Box";

export default function CardImage({ image, children, ...props }) {
  return (
    <Box
      display="flex"
      justifyContent="center"
      mb={2}
      bgcolor="#f4f6f8"
      borderRadius="4px"
      width="100%"
      height={130}
      alignItems="center"
      {...props}
    >
      {image ? (
        <img
          style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
          src={image}
          alt="asset image"
        />
      ) : (
        children
      )}
    </Box>
  );
}
